__turbopack_context__.v({
  "container": "index-module-scss-module__hFwxXq__container",
  "feature": "index-module-scss-module__hFwxXq__feature",
  "features": "index-module-scss-module__hFwxXq__features",
  "horizontal-image": "index-module-scss-module__hFwxXq__horizontal-image",
  "list": "index-module-scss-module__hFwxXq__list",
  "modal-button": "index-module-scss-module__hFwxXq__modal-button",
  "modal-button-base": "index-module-scss-module__hFwxXq__modal-button-base",
  "modal-container": "index-module-scss-module__hFwxXq__modal-container",
  "modal-header": "index-module-scss-module__hFwxXq__modal-header",
  "modal-subtitle": "index-module-scss-module__hFwxXq__modal-subtitle",
  "modal-title": "index-module-scss-module__hFwxXq__modal-title",
  "title": "index-module-scss-module__hFwxXq__title",
  "vertical-image": "index-module-scss-module__hFwxXq__vertical-image",
});
